'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var useLanguage = require('../../hooks/useLanguage.js');
var DebugProvider = require('../../providers/DebugProvider.js');
var index = require('../StyledMarkup/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

const Language = _ref => {
  let {
    langKey,
    replacementTokens = [],
    defaultString,
    noWrap,
    style,
    tagName,
    attributes
  } = _ref;
  const {
    value
  } = useLanguage["default"]({
    langKey,
    replacementTokens,
    defaultString
  });
  const debug = React.useContext(DebugProvider.DebugContext);
  if (debug) return /*#__PURE__*/React__default["default"].createElement(index["default"], {
    "data-language-key": langKey,
    style: style,
    "data-replacement-tokens": replacementTokens.map(_ref2 => {
      let {
        token
      } = _ref2;
      return token;
    }).join(','),
    content: value
  });
  return /*#__PURE__*/React__default["default"].createElement(index["default"], {
    content: value,
    tagName: tagName,
    attributes: attributes,
    noWrap: noWrap,
    style: style
  });
};

exports["default"] = Language;
